import styled from 'styled-components';
import { getDimension } from 'styled/helpers/getDimension';

export const StyledHeader = styled.h3`
  // overriding h3 margin
  margin-top: ${getDimension('size8')};
  margin-bottom: 0;
`;
